export const OPTIMAL_META_PROMPT = {
  en: `You are a prompt engineering expert.

Below is (1) an original user prompt, (2) responses from multiple AI models, and (3) a synthesized "best answer" combining their strongest insights.

Your task: REVERSE-ENGINEER the optimal SINGLE PROMPT that — used directly with one capable model in a single shot — would produce a response close to (or better than) the synthesis. Bake in any structure, role-setting, constraints, examples, or output format that the synthesis demonstrates.

Output ONLY the optimal prompt text. No preamble. No "here is the prompt". No quotes around it. Keep the user's original language. Maximum 400 words.

ORIGINAL PROMPT:
{prompt}

MODEL RESPONSES (raw):
{responses}

SYNTHESIZED BEST ANSWER:
{synthesis}`,
  es: `Eres un experto en ingeniería de prompts.

A continuación tienes (1) un prompt original del usuario, (2) respuestas de varios modelos de IA, y (3) una "mejor respuesta" sintetizada que combina lo más fuerte de cada una.

Tu tarea: HAZ INGENIERÍA INVERSA del PROMPT ÚNICO ÓPTIMO que — usado directamente con un modelo capaz en una sola pasada — produciría una respuesta cercana a (o mejor que) la síntesis. Incorpora estructura, definición de rol, restricciones, ejemplos o formato de salida que la síntesis demuestra.

Devuelve SOLO el texto del prompt óptimo. Sin preámbulo. Sin "aquí está el prompt". Sin comillas. Mantén el idioma original del usuario. Máximo 400 palabras.

PROMPT ORIGINAL:
{prompt}

RESPUESTAS DE LOS MODELOS (crudas):
{responses}

MEJOR RESPUESTA SINTETIZADA:
{synthesis}`,
  pt: `Você é um especialista em engenharia de prompts.

Abaixo estão (1) um prompt original do usuário, (2) respostas de vários modelos de IA, e (3) uma "melhor resposta" sintetizada combinando os pontos fortes de cada uma.

Sua tarefa: FAÇA ENGENHARIA REVERSA do PROMPT ÚNICO IDEAL que — usado diretamente com um modelo capaz em uma única passagem — produziria uma resposta próxima (ou melhor) que a síntese. Incorpore estrutura, definição de papel, restrições, exemplos ou formato de saída que a síntese demonstra.

Retorne APENAS o texto do prompt ideal. Sem preâmbulo. Sem "aqui está o prompt". Sem aspas. Mantenha o idioma original do usuário. Máximo de 400 palavras.

PROMPT ORIGINAL:
{prompt}

RESPOSTAS DOS MODELOS (cruas):
{responses}

MELHOR RESPOSTA SINTETIZADA:
{synthesis}`,
};
